import React, { useEffect, useState } from 'react'
import CenterContent from '../Components/CenterContent/CenterContent'
import { observer } from 'mobx-react-lite'
import fileUpload from '../Utils/fileUpload'
import {toast} from 'react-toastify'
import Compressor from 'compressorjs';

export const CheckEDSContainer = observer(function () {
    const [loaded, setLoaded] = useState(0);

    const checkFileSize = (event) => {
        if (!event.target.files[0]) return false;
        let file = event.target.files[0];
        let size = fileUpload.MAX_FILE_SIZE; //15mb
        if (file.size > size) {
            event.target.value = null;
            toast.error('Загружаемый файл слишком большой для обработки сервером.');
            return false;
        }
        return true;
    };

    const CompressFile = (file, parent) => {
        console.log('input ', file);
        const options = {
            strict: fileUpload.STRICT,
            checkOrientation: fileUpload.CHECKORIENTATION,
            maxWidth: fileUpload.MAXWIDTH,
            maxHeight: fileUpload.MAXHEIGHT,
            minWidth: fileUpload.MINWIDTH,
            minHeight: fileUpload.MINHEIGHT,
            width: fileUpload.WIDTH,
            height: fileUpload.HEIGHT,
            quality: fileUpload.QUALITY,
            mimeType: fileUpload.MIMETYPE,
            convertSize: fileUpload.CONVERTSIZE,
            success: function (result) {
                console.log('Output: ', result);
                // if (file.size >= result.size) return parent.onClickHandler(result);
                // one file if compressed size less
                // return parent.onClickHandler(file); // one file if compressed size larger than self
            },
            error: function (err) {
                toast.error(`Ошибка сжатия файла: ${err.message}`);
            },
        };
        new Compressor(file, options);
    };

    const isImage = (file) => {
        if (file.type.split('/')[0] === 'image') return true;
        return false;
    };

    const onChangeHandler = (event) => {
        if (checkFileSize(event)) {
            setLoaded(0);
            let file = event.target.files[0];
            if (isImage(file)) CompressFile(file, this);
            // else onClickHandler(file);
        }
    };

	return (
		<CenterContent>
	 <label htmlFor="file">Выберите файл</label>
 <input type="file" id="file" name="file" onChange={onChangeHandler} />

		</CenterContent>
	)
})
